import { useCreateFieldGetter, useGetPageField } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Chat Message component customisation
 * Returns styling for chatbot and user message bubbles, and chatbot icon
 */
export const useChatMessageCustomisation = () => {
  // Chatbot bubble customisation
  const { getField: getChatbotBubbleField, isVisible: chatbotBubbleVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.CHATBOT_SECTION_KEYS.CHATBOT_BUBBLE,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.CHATBOT,
  });

  // User bubble customisation
  const { getField: getUserBubbleField, isVisible: userBubbleVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.CHATBOT_SECTION_KEYS.USER_BUBBLE,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.CHATBOT,
  });

  // Chatbot icon from theme
  const chatbotIcon = useGetPageField({
    registryId: PUI.REGISTRY_IDS.DEFAULT_THEME,
    blockKey: PUI.THEME_BLOCK_KEYS.BRAND_ASSETS,
    sectionKey: PUI.THEME_SECTION_KEYS.CHATBOT_CHAT_ICON,
    fieldKey: PUI.THEME_FIELD_KEYS.CHAT_ICON,
  });

  // Brand primary color from theme
  const brandPrimaryColor = useGetPageField({
    registryId: PUI.REGISTRY_IDS.DEFAULT_THEME,
    blockKey: PUI.THEME_BLOCK_KEYS.COLORS,
    sectionKey: PUI.THEME_SECTION_KEYS.BRAND_COLORS,
    fieldKey: PUI.THEME_FIELD_KEYS.PRIMARY,
  });

  const chatbotBubbleTextColor = getChatbotBubbleField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const chatbotBubbleBackgroundColor = getChatbotBubbleField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);

  const userBubbleTextColor = getUserBubbleField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const userBubbleBackgroundColor = getUserBubbleField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);

  return {
    chatbotIcon,
    brandPrimaryColor,
    chatbotBubbleTextColor,
    chatbotBubbleBackgroundColor,
    chatbotBubbleVisible,
    userBubbleTextColor,
    userBubbleBackgroundColor,
    userBubbleVisible,
  };
};
